import { useResponsive } from '../../../hooks/useResponsive';
import ContactCardDesktop from './ContactCardDesktop';
import ContactCardMobile from './ContactCardMobile';

interface ContactCardProps {
  label: string;
  name: string;
  email: string;
  phone: string;
}

const ContactCard = (props: ContactCardProps) => {
  const breakpointIndex = useResponsive([768]);

  if (breakpointIndex === 0) {
    return <ContactCardMobile {...props} />;
  }
  return <ContactCardDesktop {...props} />;
};

export default ContactCard;
